import React from 'react';
import { appendScript } from '../../../lib/dom';

export type ActiveCampaignFormProps = {
    activeCampaignId: number;
};

export const ActiveCampaignForm = ({
    activeCampaignId,
}: ActiveCampaignFormProps) => {
    React.useEffect(() => {
        const id = `activeCampaignScript${activeCampaignId}`;
        appendScript(
            `https://alude.activehosted.com/f/embed.php?id=${activeCampaignId}`,
            id
        );
        return () => {
            const e = document.getElementById(id);
            if (e) e.parentNode?.removeChild(e);
        };
    }, []);
    return <div className={`_form_${activeCampaignId}`} />;
};
